(function ($) {
    $(function () {
        $('.content__main').align({
            selector: '.single-product > *:not(.single-product__rating)',
        });
    });
})(jQuery);